module.exports = __webpack_public_path__ + "static/media/arrows-downwards.99c7e8f7.svg";